module.exports = __webpack_public_path__ + "static/media/21-14.9b7f5ee7.mp3";